module.exports = "pegasus_template/assets/styleGroup2-youtube.gif";